import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Checkbox from "app/components/UI/Checkbox";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import classes from "./CheckoutDetail.module.css";

export const CheckoutDetail = ({
  translate,
  intl,
  clubId,
  onCheckoutConfirm,
  onCheck,
  isInputChecked,
  sale,
  articles
}) => (
  <div className={classes.checkoutDetailContainer}>
    <div className={classes.checkoutDetail__table}>
      <div className={classes.checkoutDetail__table__header}>{articles.size} Article(s)</div>
      <div className={classes.checkoutDetail__table__content}>
        <Flex direction="row" className={classes.checkoutDetail__table__content__row}>
          <Flex size={1}>{translate("Total HT")}</Flex>
          <div>
            {intl.formatNumber(sale.get("totalTE") / 100, {
              style: "currency",
              currency: "EUR"
            })}
          </div>
        </Flex>
        <Flex direction="row" className={classes.checkoutDetail__table__content__row}>
          <Flex size={1}>{translate("TVA 20%")}</Flex>
          <div>
            {intl.formatNumber(sale.getIn(["totalTaxes", "2000"]) / 100, {
              style: "currency",
              currency: "EUR"
            })}
          </div>
        </Flex>
        <div className={classes.checkoutDetail__table__footer}>
          <Flex direction="row">
            <Flex size={1}>{translate("Total TTC")}</Flex>
            <div>
              {intl.formatNumber(sale.get("totalTI") / 100, {
                style: "currency",
                currency: "EUR"
              })}
            </div>
          </Flex>
        </div>
      </div>
    </div>

    <Flex direction="row" middle className={classes.checkoutDetail__contract}>
      <Checkbox className={classes.checkoutDetail__radio} onCheck={onCheck} />
      <span>
        {translate("En cliquant ici j'accèpte les termes et ")}
        <Link className={classes.checkoutDetail__contract__link} to="/CGV" target="_blank">
          {translate("conditions générales de vente")}
        </Link>.
      </span>
    </Flex>

    <div>
      <Button
        primary
        disabled={!isInputChecked}
        label={translate("Poursuivre ma commande")}
        fullWidth
        onClick={onCheckoutConfirm}
      />
      <Link className={classes.checkoutDetail__link} to={formatPattern("/:clubId/shop", { clubId: clubId })}>
        <Button className={classes.checkoutDetail__action} label={translate("Revenir à la boutique")} fullWidth />
      </Link>
    </div>
  </div>
);

CheckoutDetail.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  onCheckoutConfirm: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  isInputChecked: PropTypes.bool.isRequired,
  sale: ImmutablePropTypes.map.isRequired,
  articles: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  clubId: PropTypes.string.isRequired
};

export default CheckoutDetail;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutCart/CheckoutDetail/CheckoutDetail.js